const mediaItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20scene%20with%20dramatic%20explosion%20and%20heroic%20figure%20silhouette%20against%20fiery%20orange%20sky%2C%20epic%20action%20movie%20atmosphere%2C%20cinematic%20lighting%20with%20warm%20golden%20flames%2C%20wide%20landscape%20composition%2C%20no%20text&width=900&height=500&seq=media-trailer-01&orientation=landscape',
    title: '流浪地球3 终极预告',
    duration: '2:38',
    tag: '预告片',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20ancient%20Chinese%20battlefield%20scene%20with%20warriors%20in%20armor%20under%20dramatic%20stormy%20sky%2C%20epic%20scale%20with%20dust%20and%20banners%2C%20warm%20golden%20and%20dark%20atmospheric%20lighting%2C%20no%20text&width=900&height=500&seq=media-trailer-02&orientation=landscape',
    title: '封神第二部 幕后纪实',
    duration: '4:15',
    tag: '花絮',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20animated%20scene%20with%20a%20mythical%20dragon%20flying%20over%20ancient%20Chinese%20mountains%2C%20vibrant%20warm%20colors%20and%20flowing%20clouds%2C%20cinematic%20animation%20style%2C%20dynamic%20composition%2C%20no%20text&width=900&height=500&seq=media-trailer-03&orientation=landscape',
    title: '哪吒之魔童闹海 先导片',
    duration: '1:52',
    tag: '先导片',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20figure%20standing%20in%20a%20dark%20ancient%20Chinese%20courtyard%20with%20lanterns%20and%20shadows%2C%20atmospheric%20noir%20lighting%2C%20suspenseful%20cinematic%20composition%2C%20no%20text&width=900&height=500&seq=media-trailer-04&orientation=landscape',
    title: '大奉打更人 精彩片段',
    duration: '3:06',
    tag: '片段',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            视听预览
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            精彩预告
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            最新预告片、幕后花絮与精彩片段抢先看
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article key={item.title} className="group cursor-pointer rounded-xl overflow-hidden bg-background-100">
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`6080新视觉影院 - ${item.title}`}
                  title={`${item.title} - 6080新视觉影院`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-md bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="inline-block px-2 py-1 rounded-md bg-black/60 text-background-50 text-xs font-mono whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors">
                  {item.title}
                </h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}